import type { FaireProductEntity } from "../../entity_types/product";

export const p_rdxv7j732f: FaireProductEntity = {
  token: "p_rdxv7j732f",
  type: "product",
  name: "Textured Knit Baby Polo & Shorts Set (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/536447f7876359ae57304fc6455d8f477ed349249547861cb2f9a5f815ff8208.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9e344edcd60bbbb0dbe04baf9bebc1303f3a751cbdadb34be2b5112bda98e30.png",
    "https://cdn.faire.com/fastly/82ebd51047e9e13529a59c83f7d066995f5871ebb5caf9272447f22b0dbaf50f.png",
    "https://cdn.faire.com/fastly/92055dedc249fc17deb0e2dc7d6cba7e0df1544d5c9664cf3af6f70204761db6.png",
    "https://cdn.faire.com/fastly/4397e4c1665391902669a4c4fb786b26e47051df4a7f974a71e64dd1c1a9ef77.png",
    "https://cdn.faire.com/fastly/9d04ef7fbbea51476336288517928bbd8b3db20c13928cd503f42742ebac659c.png",
  ],
  priceDollars: 34,
  description:
    "Timeless, soft, and naturally breathable, this premium organic cotton Baby Textured Knit Baby Polo & Shorts Set is thoughtfully crafted for lightweight everyday comfort.\n\nOur 100% organic cotton baby sweater is thoughtfully made as a truly special piece, blending timeless beauty, comfort, and sustainability. Designed for families who value thoughtfully made organic baby clothes, it reflects heirloom-quality craftsmanship and refined design.\n\nWhy It’s Special:\n\n• Heirloom-Quality Organic Cotton\nBreathable, 100% organic cotton with exceptional softness and a beautiful finish.\n\n• Safe, Non-Toxic & Gentle\nEco-friendly, chemical-free materials and gentle dyes for delicate skin.\n\n• Crafted to Last\nMeticulous detailing ensures lasting quality and comfort.\n\n• Designed in the USA, Responsibly Made\nDesigned in the USA and ethically produced in India, supporting sustainable practices.\n\n• Timeless Design\nWhimsical yet refined details for everyday moments and special occasions.\n\nPerfect for Gifting\nWith its heirloom-quality feel and timeless design, this organic cotton baby sweater makes a meaningful gift for baby showers, newborns, and first holidays.\n\nChoose Viverano Organics for heirloom-quality organic baby clothing—thoughtfully designed for little ones and the planet. Happy baby. Happy earth.",
  tags: [],
  msrpDollars: 68,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:51.200Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
